package org.catharsis.spendtel.di

import org.catharsis.spendtel.core.api.AnalyticsApi
import org.catharsis.spendtel.core.api.PreferencesManager
import org.catharsis.spendtel.core.impl.NoOpAnalyticsApi
import org.catharsis.spendtel.core.impl.WebPreferencesManagerImpl
import org.koin.core.module.Module
import org.koin.dsl.bind
import org.koin.dsl.module

actual fun platformDataModule(): Module = module {
    includes(clientDataModule)
    single<AnalyticsApi> { NoOpAnalyticsApi() }
    single { WebPreferencesManagerImpl() }.bind<PreferencesManager>()
}
